import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { SpecificFields } from '@clients/models/client.model';
import { SharedClientConfigurationService } from '@services/client/sharedClientConfiguration.service';
import { map, Observable, take } from 'rxjs';
import { getRedirectionUrl } from '@shared/utils/role-based-redirection-utils';
import { ROLE_REDIRECT_MAP } from '@shared/constants/constant';

/**
 * Redirect to another url depending on conditions stored in dataref
 * @returns url to redirect to
 */
export const HomeGuard: CanActivateFn = (): Observable<UrlTree> => {
  const sharedClientConfigurationService = inject(SharedClientConfigurationService);
  const router = inject(Router);
  const authorizations = JSON.parse(localStorage.getItem('profile') ?? '{}')?.authorizations;
  return sharedClientConfigurationService.specificFields$.pipe(
    take(1),
    map((fields: SpecificFields) => getRedirectionUrl(ROLE_REDIRECT_MAP, authorizations, fields, router)),
  );
};
